import React, { useEffect, useState } from 'react'
import api from '../../apis/pc/conversation/conversation'
import CommonSelect from "../common/select/commonSelect";
import { getParameterByName } from "@/utils/utils";

const OutPeopleSelect = (props) => {
  const initCondition = { name: '', pageNum: 1, pageSize: 50 }
  const [condition, setCondition] = useState(initCondition)
  const [hasNextPage, setHasNextPage] = useState(true)
  const [list, setList] = useState([])
  let type = getParameterByName("deviceType") === "iframe" ? 2 : 1;

  const getData = () => {
    let temp = JSON.parse(JSON.stringify(list))
    api.getOutPeople({ ...condition, type }).then(res => {
      const { code, data } = res
      if (code === 0) {
        data.list.forEach(item => {
          temp.push({
            id: item.wxUserId,
            name: item.name,
            company: item.corpName,
            extendUserType: item.extendUserType
          })
        })
        setList(temp)
        setHasNextPage(data.hasNextPage)
      } else {
        setList([])
      }
    })
  }

  const changeCondition = (value) => {
    if (condition.name !== value.name) {
      setList([])
    }
    setCondition({ ...condition, ...value })
  }

  const reset = () => {
    setList([])
    setCondition(initCondition)
  }

  useEffect(() => {
    getData()
  }, [condition])
  return (
    <CommonSelect
      width={240}
      list={list}
      placeholder={'搜索参与人'}
      handleConditionChange={changeCondition}
      handleChange={(value) => props.getOutConnect(value)}
      reset={reset}
      allowClear={true}
      condition={condition}
      initCondition={initCondition}
      hasNextPage={hasNextPage}
    />
  )
}

export default OutPeopleSelect
